export const verticalMediaQueries: {
    short: string;
    tall: string;
    grande: string;
    venti: string;
} = {
    short: '(max-height: 400px)',
    tall: '(max-height: 600px)',
    grande: '(max-height: 800px)',
    venti: '(min-height: 801px)'
};

export const horizontalMediaQueries: {
    mobile: string;
    tablet: string;
    desktop: string;
} = {
    mobile: '(max-width: 768px)',
    tablet: '(min-width: 769px) and (max-width: 1024px)',
    desktop: '(min-width: 1025px)'
};
